module.exports = __webpack_public_path__ + "media/images/achievement_category/login_count-03881cce53e94621e23850c2da549d81.png";